import { HTTPStatuses } from '@packages/domain/constants/http';
import {
  FETCH_TRACKING_PAGE_FAILURE,
  FETCH_TRACKING_PAGE_REQUEST,
  FETCH_TRACKING_PAGE_SUCCESS,
  FETCH_TRACKING_PAGE_SUCCESS_WITHOUT_RESULTS,
  FETCH_TRACKING_SETUP_DATA_FAILURE,
  FETCH_TRACKING_SETUP_DATA_REQUEST,
  FETCH_TRACKING_SETUP_DATA_SUCCESS,
} from 'constants/index';
import type { Dispatch } from 'redux';
import {
  getCurrentLocale,
  getPayment,
  getPaymentId,
  isFetching,
} from 'selectors';
import type { PayexService } from 'services/payex';
import { errorNotifier } from 'utils/errorNotifier/errorNotifier';

export const fetchTrackingPage =
  () =>
  async (
    dispatch: Dispatch,
    getState: () => Record<string, unknown>,
    { payex }: { payex: PayexService },
  ) => {
    const state = getState();
    const isFetchingTrackingPage = isFetching(state, 'trackingPage');
    const paymentId = getPaymentId(state);

    if (!paymentId || isFetchingTrackingPage) {
      return;
    }

    dispatch({ type: FETCH_TRACKING_PAGE_REQUEST });

    const { token } = getPayment(state);
    const locale = getCurrentLocale(state);
    try {
      const response = await payex.trackingPage.fetch({
        paymentId,
        token,
        locale,
      });

      return dispatch({
        type: FETCH_TRACKING_PAGE_SUCCESS,
        payload: response,
      });
    } catch (error) {
      const { status } = error;

      if (status === HTTPStatuses.NOT_FOUND) {
        return dispatch({
          type: FETCH_TRACKING_PAGE_SUCCESS_WITHOUT_RESULTS,
        });
      }

      errorNotifier.notify(error);

      return dispatch({ type: FETCH_TRACKING_PAGE_FAILURE });
    }
  };

export const fetchTrackingSetupData =
  (orderId: string, orderToken: string) =>
  async (
    dispatch: Dispatch,
    getState: () => Record<string, unknown>,
    { payex }: { payex: PayexService },
  ) => {
    const state = getState();
    const isFetchingData = isFetching(state, 'trackingSetupData');

    if (isFetchingData) {
      return;
    }

    dispatch({ type: FETCH_TRACKING_SETUP_DATA_REQUEST });

    try {
      const response = await payex.trackingPage.data(orderId, orderToken);

      dispatch({
        type: FETCH_TRACKING_SETUP_DATA_SUCCESS,
        payload: response,
      });
    } catch (error) {
      const { status } = error;
      if (status !== HTTPStatuses.NOT_FOUND) {
        error.message = `${FETCH_TRACKING_SETUP_DATA_FAILURE} ${error.message}`;
        errorNotifier.notifyWithFingerprint(error, [
          FETCH_TRACKING_SETUP_DATA_FAILURE,
          status,
        ]);
      }

      return dispatch({
        type: FETCH_TRACKING_SETUP_DATA_FAILURE,
      });
    }
  };
